export default "__VITE_ASSET__CsZtRsSI__"